import router from '@/router';
import { isEmpty } from 'lodash';
import {
  login,
  register,
  user,
  courses,
  course,
  userSave,
  invitations,
  addInvitationCode,
  requestPasswordChange,
  changePassword,
} from '@/api/user';

import AuthResponse from '@/service/AuthResponse';
import Notifications from '@/service/Notifications';

export default {
  fetchRegister({ getters, commit }) {
    commit('resetErrors');
    return register(getters.register)
      .then(res => {
        // commit('reset');
        if (res.status === 404) {
          throw new Error('Błędny token zaproszenia!');
        }
        if (!res.ok) {
          throw new Error('Email already in use');
        }
        return res.json();
      })
      .catch(e => console.error(e) || commit('addError', e.message))
      ;
  },
  fetchLogin({ state, commit }) {
    const { email, password } = state.user;
    commit('resetErrors');
    return login({ email, password })
      .then(res => {
        commit('reset');
        if (!res.ok) {
          throw new Error('Zły email lub hasło');
        }
        return res.json();
      })
      .then(res => {
        commit('setToken', res.token);
        router.replace({ name: 'home' });
      })
      .catch(e => console.error(e) || commit('addError', e.message))
    ;
  },
  fetchUser(context) {
    const { commit, dispatch } = context;
    commit('setIsLoading', true);
    return user()
      .then(res => AuthResponse.validate(res, context))
      .then(res => {
        if (res.detail) {
          commit('reset');
          commit('addError', res.detail);
          return;
        }

        commit('setUser', res);
        return res;
      })
      .catch(e => Notifications.error(e.toString(), () => dispatch('logout')))
    ;
  },
  fetchCourses(context) {
    const { commit, dispatch } = context;
    return courses()
      .then(res => AuthResponse.validate(res, context))
      .then(res => {
        if (!res.items) {
          return false;
        }

        commit('setCourses', res.items);
        return res;
      })
      .catch(e => Notifications.error(e.toString(), () => dispatch('logout')))
    ;
  },
  fetchCourse(context, id) {
    const { commit, dispatch } = context;
    return course(id)
      .then(res => AuthResponse.validate(res, context))
      .then(res => {
        if (!res) {
          return false;
        }

        commit('setCourse', res);
        return res;
      })
      .catch(e => Notifications.error(e.toString(), () => dispatch('logout')))
    ;
  },
  fetchUserSave(context) {
    const { commit, dispatch, getters } = context;
    const user = Object.assign({}, getters.user);

    if (isEmpty(user)) {
      return;
    }

    commit('resetErrors');
    commit('resetUserPasswords');
    return userSave(user)
      .then(res => AuthResponse.validate(res, context))
      .then(res => {
        if (!res) {
          commit('addError', 'Invalid response');
          return true;
        }

        if (res.violations && res.violations.length > 0) {
          commit('setErrors', res.violations);
          return true;
        }

        if (res.detail) {
          commit('addError', res.detail);
          return true;
        }
        if (Array.isArray(res)) {
          res.map(item => {
            if (item.message) {
              commit('addError', item.message);
            }
          });
          return false;
        }
        commit('setUser', res);
        return res;
      })
      .catch(e => Notifications.error(e.toString(), () => dispatch('logout')))
    ;
  },
  fetchInvitations(context) {
    const { commit, dispatch } = context;
    return invitations()
      .then(res => AuthResponse.validate(res, context))
      .then(res => {
        if (!res.items) {
          return false;
        }

        commit('setInvitations', res.items);
        return res;
      })
      .catch(e => Notifications.error(e.toString(), () => dispatch('logout')))
      ;
  },
  fetchAddInvitationCode({ commit, dispatch }, code) {
    commit('resetErrors');
    return addInvitationCode(code)
      .then(res => {
        switch (res.status) {
          case 401: // Unauthorized
          case 403: // Forbidden
            dispatch('logout');
            return false;
          case 404: // Not Found
            commit('addError', 'Nie znaleziono kodu');
            return false;
        }

        return res.json();
      })
      .then(res => {
        if (res.detail) {
          commit('addError', res.detail);
          return false;
        }

        if (Array.isArray(res)) {
          res.map(item => {
            if (item.message) {
              commit('addError', item.message);
            }
          });
          return false;
        }

        return res;
      })
      .catch(e => Notifications.error(e.toString(), () => dispatch('logout')))
    ;
  },
  fetchRequestPasswordChange({ state, commit }) {
    const { email } = state.user;
    commit('resetErrors');
    return requestPasswordChange({ email })
      .then(res => {
        switch (res.status) {
          case 500: // Unauthorized
            commit('addError', 'Something went wrong');
            return false;
          case 404: // Not Found
            commit('addError', 'Nie znaleziono kodu');
            return false;
        }

        return res.json();
      })
      .then(res => {
        if (res.detail) {
          commit('addError', res.detail);
          return false;
        }

        if (Array.isArray(res)) {
          res.map(item => {
            if (item.message) {
              commit('addError', item.message);
            }
          });
          return false;
        }

        return res;
      })
      .catch(e => Notifications.error(e.toString()))
    ;
  },
  fetchChangePassword({ state, commit }) {
    const { confirmationToken, password: plainPassword } = state.user;
    commit('resetErrors');
    return changePassword({ confirmationToken,  plainPassword })
      .then(res => {
        switch (res.status) {
          case 500: // Unauthorized
            commit('addError', 'Something went wrong');
            return false;
          case 404: // Not Found
            commit('addError', 'Nie znaleziono kodu');
            return false;
        }

        return res.json();
      })
      .then(res => {
        if (res.detail) {
          commit('addError', res.detail);
          return false;
        }

        if (Array.isArray(res)) {
          res.map(item => {
            if (item.message) {
              commit('addError', item.message);
            }
          });
          return false;
        }

        commit('reset');
        return res;
      })
      .catch(e => Notifications.error(e.toString()))
    ;
  },
  logout({ commit }) {
    commit('reset');
    router.replace({ name: 'login' });
  },
};
